import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { PriceSection } from '../components/PriceSection';
import { StickyBar } from '../components/StickyBar';
import { X } from 'lucide-react';
const modalContent: Record<string, {
  title: string;
  body: React.ReactNode;
}> = {
  'Terminos y Condiciones': {
    title: 'Términos y Condiciones',
    body: <div style={{
      fontFamily: "'Lato', sans-serif",
      fontSize: '14px',
      color: '#4A4A4A',
      lineHeight: 1.8
    }} data-id="element-364">
        <p data-id="element-365">
          <strong data-id="element-366">Última actualización:</strong> {new Date().getFullYear()}
        </p>
        <p data-id="element-367">
          Al adquirir "Imperio de Digital Workbooks" aceptas los siguientes
          términos:
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '20px'
      }} data-id="element-368">
          1. Uso del producto
        </h4>
        <p data-id="element-369">
          Este producto es para uso personal y comercial del comprador. No está
          permitida la reventa, redistribución ni compartir el contenido con
          terceros sin autorización escrita.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-370">
          2. Resultados
        </h4>
        <p data-id="element-371">
          Los resultados varían según el esfuerzo, dedicación y circunstancias
          individuales de cada persona. No garantizamos ingresos específicos.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-372">
          3. Garantía de devolución
        </h4>
        <p data-id="element-373">
          Ofrecemos garantía de devolución completa dentro de los 7 días
          calendario posteriores a la compra. Para solicitar una devolución,
          contáctanos a través del soporte.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-374">
          4. Propiedad intelectual
        </h4>
        <p data-id="element-375">
          Todo el contenido de este producto es propiedad de Imperio Digital de
          Workbooks y está protegido por derechos de autor.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-376">
          5. Modificaciones
        </h4>
        <p data-id="element-377">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. El uso continuado del producto implica aceptación de los
          términos actualizados.
        </p>
      </div>
  },
  'Politica de Privacidad': {
    title: 'Política de Privacidad',
    body: <div style={{
      fontFamily: "'Lato', sans-serif",
      fontSize: '14px',
      color: '#4A4A4A',
      lineHeight: 1.8
    }} data-id="element-378">
        <p data-id="element-379">
          <strong data-id="element-380">Última actualización:</strong> {new Date().getFullYear()}
        </p>
        <p data-id="element-381">
          Tu privacidad es importante para nosotros. Esta política explica cómo
          recopilamos y usamos tu información.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '20px'
      }} data-id="element-382">
          1. Información que recopilamos
        </h4>
        <p data-id="element-383">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, correo electrónico y datos de pago (procesados de
          forma segura por Shopify).
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-384">
          2. Uso de la información
        </h4>
        <p data-id="element-385">
          Usamos tu información para: entregar el producto, enviarte
          actualizaciones relacionadas con tu compra y, con tu consentimiento,
          comunicaciones sobre nuevos productos.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-386">
          3. Compartir información
        </h4>
        <p data-id="element-387">
          No vendemos ni compartimos tu información personal con terceros,
          excepto los proveedores de pago necesarios para procesar tu
          transacción.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-388">
          4. Seguridad
        </h4>
        <p data-id="element-389">
          Todos los pagos son procesados de forma segura. No almacenamos datos
          de tarjetas de crédito.
        </p>
        <h4 style={{
        color: '#1C1C1E',
        marginTop: '16px'
      }} data-id="element-390">
          5. Tus derechos
        </h4>
        <p data-id="element-391">
          Puedes solicitar la eliminación de tus datos en cualquier momento
          contactándonos por soporte.
        </p>
      </div>
  },
  Soporte: {
    title: 'Soporte',
    body: <div style={{
      fontFamily: "'Lato', sans-serif",
      fontSize: '14px',
      color: '#4A4A4A',
      lineHeight: 1.8
    }} data-id="element-392">
        <p data-id="element-393">
          Estamos aquí para ayudarte. Si tienes alguna pregunta o necesitas
          asistencia, contáctanos por cualquiera de estos medios:
        </p>
        <div style={{
        background: '#EAF4EE',
        borderRadius: '12px',
        padding: '20px 24px',
        margin: '20px 0',
        border: '1px solid rgba(27,94,59,0.15)'
      }} data-id="element-394">
          <p style={{
          margin: '0 0 8px',
          fontWeight: 700,
          color: '#1B5E3B'
        }} data-id="element-395">
            📧 Correo electrónico
          </p>
          <p style={{
          margin: 0
        }} data-id="element-396">
            soporte@betterbysteps.com
          </p>
        </div>
        <div style={{
        background: '#FDF3DC',
        borderRadius: '12px',
        padding: '20px 24px',
        margin: '16px 0',
        border: '1px solid rgba(201,151,58,0.2)'
      }} data-id="element-397">
          <p style={{
          margin: '0 0 8px',
          fontWeight: 700,
          color: '#8B6914'
        }} data-id="element-398">
            ⏰ Tiempo de respuesta
          </p>
          <p style={{
          margin: 0
        }} data-id="element-399">
            Respondemos dentro de las 24–48 horas hábiles.
          </p>
        </div>
        <div style={{
        background: '#F7F7F2',
        borderRadius: '12px',
        padding: '20px 24px',
        margin: '16px 0',
        border: '1px solid #E8DDD0'
      }} data-id="element-400">
          <p style={{
          margin: '0 0 8px',
          fontWeight: 700,
          color: '#1C1C1E'
        }} data-id="element-401">
            🔄 Garantía de devolución
          </p>
          <p style={{
          margin: 0
        }} data-id="element-402">
            Si deseas solicitar tu devolución dentro de los 7 días, simplemente
            escríbenos con el asunto "Devolución" y tu número de orden. Sin
            preguntas, sin complicaciones.
          </p>
        </div>
      </div>
  }
};
export function SalesPage() {
  const [showSticky, setShowSticky] = useState(false);
  const [selectedBumps, setSelectedBumps] = useState<number[]>([]);
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const basePrice = 6.36;
  const bumpPrice = 9;
  const totalPrice = parseFloat((basePrice + selectedBumps.length * bumpPrice).toFixed(2));
  const toggleBump = (id: number) => {
    setSelectedBumps(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  useEffect(() => {
    const handleScroll = () => setShowSticky(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = activeModal ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeModal]);
  return <div style={{
    backgroundColor: '#FAFAF6',
    minHeight: '100vh'
  }} data-id="element-403">
      <nav style={{
      position: 'sticky',
      top: 0,
      zIndex: 40,
      background: 'rgba(250,250,246,0.95)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid #E8DDD0',
      padding: '13px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }} data-id="element-404">
        <span style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: '17px',
        fontWeight: 700,
        color: '#1C1C1E'
      }} data-id="element-405">
          Imperio
          <span style={{
          color: '#1B5E3B'
        }} data-id="element-406">
            Digital
          </span>
        </span>
        <a href="#precio" style={{
        fontFamily: "'Lato', sans-serif",
        fontSize: '12px',
        fontWeight: 700,
        color: '#1B5E3B',
        textDecoration: 'none',
        border: '1px solid #1B5E3B',
        padding: '7px 16px',
        borderRadius: '100px'
      }} data-id="element-407">
          Obtener por $6.36
        </a>
      </nav>

      <main data-id="element-408">
        <HeroSection data-id="element-409" />
        <PainSection data-id="element-410" />
        <ObjectionsSection data-id="element-411" />
        <SolutionSection data-id="element-412" />
        <TestimonialsSection data-id="element-413" />
        <GuaranteeSection data-id="element-414" />
        <FAQSection data-id="element-415" />
        <PriceSection selected={selectedBumps} toggleBump={toggleBump} totalPrice={totalPrice} data-id="element-416" />
      </main>

      <footer style={{
      background: '#1C1C1E',
      padding: '44px 24px',
      textAlign: 'center'
    }} data-id="element-417">
        <p style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: '18px',
        fontWeight: 700,
        color: '#C9973A',
        marginBottom: '6px'
      }} data-id="element-418">
          Imperio
          <span style={{
          color: '#E8DDD0'
        }} data-id="element-419">
            Digital
          </span>
        </p>
        <p style={{
        fontFamily: "'Lato', sans-serif",
        fontSize: '12px',
        color: '#6A6A6A',
        marginBottom: '16px'
      }} data-id="element-420">
          &copy; {new Date().getFullYear()} Imperio Digital de Workbooks. Todos
          los derechos reservados.
        </p>
        <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        flexWrap: 'wrap',
        marginBottom: '20px'
      }} data-id="element-421">
          {['Terminos y Condiciones', 'Politica de Privacidad', 'Soporte'].map(link => <button key={link} onClick={() => setActiveModal(link)} style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '12px',
          color: '#6A6A6A',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          textDecoration: 'underline',
          textUnderlineOffset: '3px'
        }} data-id="element-422">
                {link}
              </button>)}
        </div>
        <p style={{
        fontFamily: "'Lato', sans-serif",
        fontSize: '11px',
        color: '#4A4A4A',
        maxWidth: '560px',
        margin: '0 auto',
        lineHeight: 1.6
      }} data-id="element-423">
          Descargo de responsabilidad: Los resultados pueden variar. Este
          producto no garantiza ingresos especificos. El exito depende de tu
          dedicacion, esfuerzo y circunstancias individuales.
        </p>
        <p style={{
        fontFamily: "'Lato', sans-serif",
        fontSize: '10px',
        color: '#3A3A3A',
        maxWidth: '520px',
        margin: '14px auto 0',
        lineHeight: 1.6,
        borderTop: '1px solid #2E2E2E',
        paddingTop: '14px'
      }} data-id="element-424">
          <strong style={{
          color: '#5A5A5A'
        }} data-id="element-425">
            AVISO LEGAL:
          </strong>{' '}
          Este sitio no es parte de Facebook™ ni de Meta Platforms, Inc.
          Además, este sitio NO está respaldado por Facebook™ de ninguna
          manera. FACEBOOK™ es una marca registrada de META PLATFORMS, INC. Los
          testimonios y ejemplos de resultados en esta página son casos
          excepcionales y no representan resultados típicos. Las ganancias
          individuales dependen de múltiples factores, incluyendo experiencia,
          dedicación y condiciones del mercado.
        </p>
      </footer>

      {/* Legal Modals */}
      <AnimatePresence data-id="element-426">
        {activeModal && modalContent[activeModal] && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={() => setActiveModal(null)} style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(28,28,30,0.7)',
        backdropFilter: 'blur(4px)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px'
      }} data-id="element-427">
            <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 16,
          scale: 0.97
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} style={{
          background: '#FAFAF6',
          borderRadius: '20px',
          maxWidth: '580px',
          width: '100%',
          maxHeight: '80vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 32px 80px rgba(0,0,0,0.4)'
        }} data-id="element-428">
              {/* Modal header */}
              <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px 24px',
            borderBottom: '1px solid #E8DDD0',
            flexShrink: 0
          }} data-id="element-429">
                <h3 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '20px',
              fontWeight: 700,
              color: '#1C1C1E',
              margin: 0
            }} data-id="element-430">
                  {modalContent[activeModal].title}
                </h3>
                <button onClick={() => setActiveModal(null)} style={{
              background: '#F2EDE4',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              flexShrink: 0
            }} data-id="element-431">
                  <X size={16} color="#4A4A4A" data-id="element-432" />
                </button>
              </div>
              {/* Modal body */}
              <div style={{
            padding: '24px',
            overflowY: 'auto',
            flex: 1
          }} data-id="element-433">
                {modalContent[activeModal].body}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <StickyBar show={showSticky} totalPrice={totalPrice} data-id="element-434" />
    </div>;
}